












































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ProductCard from "@/components/ProductCard.vue";
import FilterTab from "@/components/FilterTab.vue";
import ProductCardInner from "@/components/ProductCardInner.vue";
import ProductCardContainer from "@/components/ProductCardContainer.vue";
import ProductATCModal from "@/components/ProductATCModal.vue";
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { NavigationGuard, Route, NavigationGuardNext } from 'vue-router'
import store from '@/store'
import { ROUTES_MAP } from '@/router'
import { debug } from "webpack";
import { isWishope } from "@/common/utils";

const VasCatalogProps = Vue.extend({
  computed: {
    ...mapState('vas', [
      'shopMenu'
    ]),
    ...mapState('global', [
      'cart'
    ]),
    ...mapGetters('global', [
      'hasItemsInCart'
    ]),
    ...mapGetters('vas', [
      'merchant',
      'isEnabled',
    ])
  },
  methods: {
    ...mapMutations('vas', []),
    ...mapActions('vas', [
      'fetchMenu'
    ]),
    ...mapActions('global', [
      'addToCart'
    ]),
    isWishope,

  }
})

Component.registerHooks([
  'beforeRouteEnter'
])

@Component({
  components:{
    FilterTab,
    ProductCard,
    ProductCardInner,
    ProductCardContainer,
    ProductATCModal,
  }
})

export default class VasCatalog extends VasCatalogProps {
  selectedMenu: string | null = null
  activeProduct: null | MerchantProduct = null

  selectedCategory: any = null

  get rootCategories () : Array<MerchantMenuCategory> {
    if (!this.shopMenu) return []
    const cats = this.publishedProducts.map((p: MerchantProduct) => p.microCategory).reduce((cats: any, cat: MerchantProduct) => {
      if (!cats[`${cat.name}`]) {
        cats[`${cat.name}`] = cat
      }

      return cats
    }, {})
    return Object.values(cats)
  }

  get menuFilters () : Array<{ label: string, value: string }>{
    return this.rootCategories.map((cat: MerchantMenuCategory) => ({ label: cat.name, value: cat.id }))
  }

  get activeFilterCat () : MerchantMenuCategory | void {
    // return this.rootCategories.find(({ id }) => id === this.selectedMenu)
    return this.selectedCategory;
  }

  get publishedProducts () {
    if (!this.shopMenu) return []
    return this.shopMenu.products.filter(({ published }: MerchantProduct) => published)
  }

  get visibleProducts () {
    if (!this.shopMenu || !this.selectedMenu) return []
    return this.publishedProducts.filter((product: MerchantProduct) => product.microCategory.id === this.selectedMenu)
  }

  @Watch('menuFilters')
  handleFiltersLoaded () {
    if (this.menuFilters.length) {
      this.onSelect(this.menuFilters[0].value)
    }
  }

  productCardHighlightCount (productId: string) {
    if (this.hasItemsInCart) {
      const matching = this.cart.products.filter((p: MerchantCart) => productId === p.id || productId === p.parentProduct?.id)
      let quantity = matching.reduce((quantity: number, item: any) => { quantity+= item.requestedQuantity; return quantity  }, 0)
      return quantity ? `x${quantity}` : null
    }
    return null
  }

  async getProductCategory(productCategoryId: string) {
    this.selectedCategory = await this.$tinabaAPI.$vas.getProductCategory(productCategoryId);
  }

  onSelect (value: string) {
    this.selectedMenu = value

    this.getProductCategory(value);
  }

  addProductToCart ({ quantity = 0, product }: { quantity: Number; product: MerchantProduct }) {
    this.activeProduct = null
    if (product) {
      this.addToCart({ product_id: product.id, quantity: quantity})
    }
  }

  selectProduct (product: MerchantProduct | null) {
    this.activeProduct = product
  }

  created () {
    this.fetchMenu()
  }
/*
  beforeRouteEnter (to: Route, from: Route, next: NavigationGuardNext<VasCatalog>) {
    if (store.getters['vas/hasValidAddressAndShipping']) {
      next()
    } else {
      next({ name: ROUTES_MAP.VAS_ADDRESS ,params: to.params })
    }
  } */
}
